export class TownDto {
  constructor(
    public denomination: string,
    public postalCode: string,
    public cliId: number,
    public ctmId: number,
    public isMetropole: boolean,
  ) {}
}
